export default "__VITE_ASSET__COr$UZhG__"